/* eslint-disable no-debugger */
import { Component, Vue } from 'vue-property-decorator'
import {
    gettHeaderByType,
    settHeaderByType,
    getMarketChannelType,
    getMarketChannel,
    getMarketChannelName,
    marketChannelExportData,
    delMarketChannelById,
    setMarketChanneIsUselById, getMarketChannelQrcodeById
} from '@/api/common'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

interface TableHeaderFilter {
    name: string[];
    channelType: number[];
    dutyPeople: string[];
    launchStartTimes: string[];
}
@Component({
    filters: {
        formatDate: (val: string) => { return formatDate('yyyy-MM-dd hh:mm:ss', new Date(val)) }
    },
    components:{
        MoreUsersFilter
    }
})
export default class ChannelDelivery extends Vue {
    // ------ data -------
    tableData = []
    tableHeaderFilter: TableHeaderFilter = {
        name: [],
        channelType: [],
        dutyPeople: [],
        launchStartTimes: []
    }
    channelNameFilterList = []
    channelTypeFilterList = []
    tableHeaderList: any[] = []
    tableKey = Math.random()
    tableHeadPopoverShow = false
    page = 1
    total = 0
    pageSize = 20
    loading = false
    beginAt = ''
    delChannelId: number = undefined
    delChannelDialog = false
    exportBUttonDisabled = false
    showNav = false
    menuBtn = menuBtn
    draggableList = []
    draggableListChange = []

    // ------ computed ------
    // get dutyPeopleFilterList() {
    //     return UserModule.userList
    // }

    // ------ created ------
    created() {
        this.gettHeaderByType()
        // this.getTableData()
        this.getMarketChannelType()
    }

    // 勾选统计数据项 实时更改 方法
    changeChecked(row) {
        setMarketChanneIsUselById({
            id: row.id,
            isUse: row.isUse === true ? '1' : '0',
        }).then(res => {
            this.getMarketChannelType()
        })
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    // ------ methods ------
    async gettHeaderByType() {
        this.loading = true
        const data: any = await gettHeaderByType(1)
        this.draggableListChange = data.headerUserList
        this.tableHeaderList = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableList = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
        this.getMarketChannelName()
    }
    async getMarketChannelType() {
        const data: any = await getMarketChannelType()
        this.channelTypeFilterList = data.marketChannelTypeList
    }

    async settHeaderByType() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 1})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
            this.tableHeadPopoverShow = false
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }
    async getTableData() {
        this.loading = true
        const data: any = await getMarketChannel({
            page: this.page,
            limit: this.pageSize,
            nameList: this.tableHeaderFilter.name,
            typeList: this.tableHeaderFilter.channelType,
            beginAt: this.beginAt,
            directorUserIdList: this.tableHeaderFilter.dutyPeople
        })
        this.total = data.allNum
        this.tableData = data.marketChannelList
        this.tableKey = Math.random()
        this.loading = false

        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
    }
    async getMarketChannelName() {
        const data: any = await getMarketChannelName()
        this.channelNameFilterList = data.marketChannelNameList
    }
    clickEditChannel(id: number) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newChannel?id=' + id)
        let time = null
        time = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    clickSeeChannel(id: number, cnFilds: string) {
        if(cnFilds !== '渠道名称') return
        if(!this.buttonShow(21)) return
        const win =  window.open(window.origin + this.$route.matched[0].path + '/seeChannel?id=' + id)
        let time = null
        time = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    changePage(page: number) {
        this.page = page
        this.getTableData()
    }
    changePageSize(pageSize: number) {
        this.pageSize = pageSize
        this.getTableData()
    }
    StatisticsDataSingle(row) {
        window.open(window.location.origin + this.$route.matched[0].path + '/channelStatisticsData' + '?id=' + row.id + '&name=' + row.name)
    }
    StatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/channelStatisticsData')
    }
    timePickerChange(timeArr: Date[]) {
        if(timeArr === null || timeArr === undefined || timeArr.length === 0) {
            this.beginAt = ''
            this.page = 1
            this.getTableData()
            return
        }
        if(timeArr.length > 0) {
            const time1 = formatDate('yyyy-MM-dd', new Date(timeArr[0]))
            const time2 = formatDate('yyyy-MM-dd', new Date(timeArr[1]))
            this.beginAt = time1 + '/' + time2
            this.page = 1
            this.getTableData()
        }
    }
    exportExcl() {
        this.exportBUttonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        marketChannelExportData({
            nameList: this.tableHeaderFilter.name,
            typeList: this.tableHeaderFilter.channelType,
            beginAt: this.beginAt,
            directorUserIdList: this.tableHeaderFilter.dutyPeople
        }).then(() => {
            this.exportBUttonDisabled = false
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }
    delChannel(id: number) {
        this.delChannelId = id
        this.delChannelDialog = true
    }

    async getChannelQrcode(row: any) {
        const data: any = await getMarketChannelQrcodeById(row.id)
        let elink = document.createElement('a')
        elink.href = data.qrCodeStr
        elink.download = row.marketChannelTypeName+'—' + row.name + `.png` // 渠道类型+渠道名称+
        elink.click()

        this.getTableData()
    }

    async confirmDelChannel() {
        await delMarketChannelById({id: this.delChannelId})
        this.delChannelDialog = false
        this.$message.success('删除成功')
        this.getTableData()
        this.delChannelId = undefined
    }
    buttonShow(id: number) {
        return menuBtn(id)
    }

    newMarketChannel() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newChannel', '_blank')
        const timer = setInterval(() => {
            if(win.closed) {
                clearTimeout(timer)
                this.getTableData()
            }
        }, 500)
    }

    changeuser(e){
        this.tableHeaderFilter.dutyPeople = e.id
        this.changePage(1)
    }
}
